import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

import errorImg from "../../assets/images/error.svg";

type NotFoundProps = {
  /** Destino do CTA — tenant `/dashboard` ou SA `/super-admin/dashboard`. */
  homeTo?: string;
};

/**
 * Página 404 do produto (DOC 13) — sem redirect silencioso ao dashboard.
 * Usada no catch-all tenant e SA (LAC-011 polish UX).
 */
const NotFound = ({ homeTo = "/dashboard" }: NotFoundProps) => {
  const { t } = useTranslation();
  document.title = t("errors.notFound.documentTitle");

  return (
    <div className="page-content">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="text-center pt-4 pb-5">
              <img
                src={errorImg}
                alt=""
                className="error-basic-img move-animation"
                style={{ maxWidth: 280 }}
              />
              <div className="mt-n4">
                <h1 className="display-1 fw-medium">404</h1>
                <h3 className="text-uppercase">{t("errors.notFound.title")}</h3>
                <p className="text-muted mb-4">{t("errors.notFound.description")}</p>
                <Link to={homeTo} className="btn btn-primary">
                  <i className="mdi mdi-home me-1"></i>
                  {t("errors.notFound.cta")}
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NotFound;
